import "./Services.css"

import images from "./1.jpg";
// import images_1 from "./1.png";
import images_2 from "./2.jpg";
import images_4 from "./3.png";
import images_3 from "./4.png";

import { HashLink } from 'react-router-hash-link';



import check from "./verify.png";


import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";



export default function Services() {

    useEffect(() => {
        Aos.init();
    }, []);
    
    return <main id="serviec">

        <h2  data-aos="fade-up"  data-aos-duration="1000">Not just your typical pool company.</h2>
        <h4  data-aos="fade-up"  data-aos-duration="1000">We offer a wide array of services for your outdoor spaces. Pools are just the beginning.</h4>
        
        <div className="m-cont-center">
                    <div  data-aos="fade-up"  data-aos-duration="1000" className="serv-block-1">
                        <div className="serv-bl-cont-1-1">
                            <span id="h3-span"><h3 id="mr-tit-ser">Open/Closed Pool Service</h3><h3 id="price-rl">299$</h3><h3 id="price-cr">400$</h3></span>
                            <h4>Our experts provide comprehensive pool opening and closing services to ensure your pool stays in perfect condition throughout the season.</h4>
                            <h5>Pool Opening includes:</h5>
                            <ul>
                            <span><img src={check} alt="check" className="check"/><li>Removing the protective cover and cleaning any debris. (Not more than one hour)</li></span>
                            <span><img src={check} alt="check" className="check"/><li>Inspecting and starting up the equipment (pumps, filters, and cleaning systems).</li></span>
                            <span><img src={check} alt="check" className="check"/><li>Adjusting the water's chemical balance for safe swimming.</li></span>
                            <span><img src={check} alt="check" className="check"/><li>Checking the pool for any potential damages and providing repair recommendations.</li></span>
                            </ul>

                            <h5>Pool Closing includes:</h5>
                            <ul>
                                <span><img src={check} alt="check" className="check"/><li>Cleaning the pool from debris and preparing the water for winterization. (No more than one hour)</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Lowering the water level and protecting against freezing.</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Sanitizing and adding necessary chemical treatments.</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Installing the winter cover and shutting down the equipment.</li></span>
                            </ul>

                            <HashLink to="#contact">Contact us</HashLink>

                        </div>
                        <div className="serv-bl-cont-1-2">
                            <img src={images} alt="#"  className="main-img"/>
                        </div>
                    </div>

                    <div  data-aos="fade-up"  data-aos-duration="1000" className="serv-block-2">                    
                    <div className="serv-bl-cont-2-1">
                            <h3>Weekly Pool Maintenance Service</h3>
                            <h4>Keep your pool pristine with our comprehensive maintenance packages.</h4>
                            <span><h5>STANDARD SERVICE</h5><h5 className="price-ser-2">99$</h5></span>
                            <ul>
                                <span ><img src={check} alt="check" className="check"/><li>REMOVING LEAVES AND DEBRIS</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>EMPTYING ALL BASKETS </li></span>
                                <span ><img src={check} alt="check" className="check"/><li>POOL VACUUMING</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>BRUSHING WALLS</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>BACKWASHING SYSTEM IF APPLICABLE</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>CHECKING THE LEVEL OF WATER</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>WATER TESTING</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>ADDING CHEMICALS (NOT INCLUDED IN THE PRICE)</li></span>
                            </ul>
                            <span><h5>LUXURY SERVICE</h5><h5 className="price-ser-2">175$</h5></span>
                            <ul>
                                <span ><img src={check} alt="check" className="check"/><li>STANDARD SERVICE</li></span>
                                <span ><img src={check} alt="check" className="check"/><li> CHECKING FOR ANY VISIBLE LEAKS AND DAMAGES</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>CHECKING PROPER OPERATION OF PUMPS, LIGHTS AND HEATER</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>TESTING SALT LEVELS</li></span>
                                <span ><img src={check} alt="check" className="check"/><li> CLEANING THE POOL DECK</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>CLEANING THE AUTOMATIC POOL COVER</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>ADDING CHEMICALS (NOT INCLUDED IN THE PRICE)</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>CLEANING AUTO CLEANER BAG AND WALL SCREEN IF APPLICABLE</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>CHECKING THE FILTRATION SYSTEM. MAKING SURE THE WATER CIRCULATES PROPERLY</li></span>
                            </ul>

                            <HashLink to="#contact">Contact us</HashLink>
                        </div>
                        <div className="serv-bl-cont-2-2"><img src={images_2} alt="#"  className="main-img"/></div>
                    </div>

                    <div data-aos="fade-up"  data-aos-duration="1000" className="serv-block-3">

                        <div className="serv-bl-cont-3-1">
                        <h3>Additional Services</h3>
                        <h4>Tailor your pool care with our specialized offerings</h4>
                
                            <ul>
                                <span ><img src={check} alt="check" className="check"/><li>Protective Covers</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>Liner Replacement</li></span>
                                <span ><img src={check} alt="check" className="check"/><li>Equipment Repair</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Driveways & Walkways</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Patios</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Fireplaces & Firepits</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Decks & Fencing</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Sodding</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Pergola & Pavilions</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Outdoor Kitchens</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Retaining Walls</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Stonework</li></span>
                                <span><img src={check} alt="check" className="check"/><li>Re-Design of Pool Hardscaping</li></span>
                            </ul>

                        </div>

                        <div className="serv-bl-cont-3-2">
                            <img src={images_3} alt="#"  className="main-img"/>
                        </div>
                        
                    </div>

        </div> 

        <h2  data-aos="fade-up"  data-aos-duration="1000" id="deisgn">Let’s talk about design.</h2>
        <h4  data-aos="fade-up"  data-aos-duration="1000">Elevate your design with 3D perspective.</h4>
            
        <div className="m-cont-center">         

                    <div  data-aos="fade-up"  data-aos-duration="1000" className="serv-block-4">
                        <div className="serv-bl-cont-4">
                            <h6>DESIGN + BUILD</h6>
                            <h3>We are a design + build residential outdoor construction company. It all starts with a design and a plan.</h3>
                        </div>

                        <div className="serv-bl-cont-4">
                            <img src={images_4} alt="#"  className="main-img"/>
                        </div>
                    </div>
                </div>               
    </main>
}
